var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefiance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 832,
    height: 77,
    viewBox: "0 0 832 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6605 2.16761H0V74.4213H36.6605C63.5105 74.4213 80.6532 60.5898 80.6532 38.2944C80.6532 15.999 63.5105 2.16761 36.6605 2.16761ZM35.7311 63.5831H12.3923V13.0056H35.7311C54.7325 13.0056 67.9509 21.5729 67.9509 38.2944C67.9509 55.0161 54.7325 63.5831 35.7311 63.5831Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.908 63.5831V43.1458H162.27V32.3077H112.908V13.0056H171.565V2.16761H100.619V74.4213H172.597V63.5831H112.908Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M262.598 13.1089V2.16761H191.859V74.4213H204.251V45.4165H253.614V34.3721H204.251V13.1089H262.598Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M292.364 74.4213V2.16761H279.972V74.4213H292.364Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M385.52 74.4213H399.048L360.011 2.16761H346.38L307.241 74.4213H320.666L329.857 56.9773H376.225L385.52 74.4213ZM335.434 46.4487L353.092 13.0056L370.752 46.4487H335.434Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M481.377 2.16761V56.9773L427.263 2.16761H414.043V74.4213H426.022V17.4441L482.514 74.4213H493.457V2.16761H481.377Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M557.74 65.6475C538.635 65.6475 525.932 56.3578 525.932 38.2944C525.932 20.231 538.635 10.9413 557.74 10.9413C569.512 10.9413 578.702 14.8636 584.076 23.7405L595.639 17.9602C588.929 7.63825 575.709 0 557.948 0C530.373 0 513.336 14.5539 513.336 38.2944C513.336 62.0351 530.373 76.5888 557.432 76.5888C575.709 76.5888 588.929 69.054 595.743 58.5254L584.28 52.8482C578.806 61.8283 569.512 65.6475 557.74 65.6475Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M625.656 63.5831V43.1458H675.018V32.3077H625.656V13.0056H684.312V2.16761H613.365V74.4213H685.345V63.5831H625.656Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M709.307 28.9362V18.584H730.577V15.2055H709.307V5.3731H734.409V1.99455H705.69V32.3147H734.841V28.9362H709.307Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M770.305 1.99455H738.227V5.28647H752.436V32.3147H756.053V5.28647H770.305V1.99455Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M804.929 5.3731V1.99455H776.252V32.3147H779.869V19.3637H801.139V15.9852H779.869V5.3731H804.929Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M819.77 18.6273C814.647 18.2375 810.426 17.6744 810.426 14.729C810.426 11.5671 815.291 10.7008 818.865 10.7441C823.214 10.7874 826.357 12.3034 828.553 14.2093L830.794 11.827C828.21 9.70454 823.776 7.79871 819.039 7.79871C812.105 7.79871 806.94 10.311 806.94 14.9456C806.94 19.7969 812.837 21.1396 819.039 21.6594C825.024 22.1792 828.51 22.9588 828.51 25.9042C828.51 28.763 824.678 30.279 819.813 30.279C814.905 30.279 811.331 28.633 808.273 26.0342L806.035 28.1566C809.652 31.3618 814.343 33.2243 819.728 33.2243C827.736 33.2243 832 29.8025 832 25.5577C832 20.9663 826.831 19.1904 819.77 18.6273Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefiance);
export default __webpack_public_path__ + "static/media/Defiance.f16f37180fc412df4167ad318b1d17f9.svg";
export { ForwardRef as ReactComponent };